// also update airbnbdata to initial!
const initialValues = {
  fullName: '',
  email: '',
  phone: '',
  zipcode: '',
  houseNumber: '',
  houseNumberInput: '',
  houseNumberAddition: '',
  city: '',
  street: '',
  allowedPrivacy: false,
  allowedGeneralTerms: false,
  allowedProxy: false,
  allowedAgreement: false,
  allowedAirbnbActionMail: true,
  allowedRelatedActionsMail: false,
}

export default initialValues
